import { type Query, type QueryParams } from "./typed";

const searchBoxMapper = () => {
  return {
    createURL: (query: Query): QueryParams => {
      return {
        query,
      };
    },
    parseURL: (queryParams: QueryParams): Query => {
      const searchBoxQuery = queryParams.query;

      if (searchBoxQuery && typeof searchBoxQuery === "string") {
        return searchBoxQuery;
      }

      return undefined;
    },
  };
};

export {
  searchBoxMapper,
};
